<template>
  <b-card>
    <b-table
      head-variant="dark"
      striped
      hover
      bordered
      show-empty
      :items="items"
      :fields="fields"
    >
      <template v-slot:cell(no)="data">
        {{ data.index + 1 }}
      </template>
    </b-table>
  </b-card>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    onClickBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="css" scoped></style>
